import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

const OtherOption = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const {form_component, checkedValue} = props;
	let fieldname;
	const regex = /^profile_custom_fields\[(.+)\]$/;
	const match = regex.exec(form_component.fieldname);
	if (match) {
		fieldname = `profile_custom_fields[${match[1]}_other]`;
	} else {
		fieldname = `${form_component.fieldname}_other`;
	}

	const fv = useSelector(state => state.fv);
	//console.log("fv", fv);

	const userData = useSelector(state => state.userData);
	const cbFieldOtherData = useSelector(state => state.cbFieldOtherData);

	const [inputValue, setInputValue] = useState('');

	useEffect(() => { // to be updated after render
		if (fv) {
			if (checkedValue === 'other') {
				//console.log(`add other validator, fieldname`, fieldname);

				fv.addField(fieldname, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					}
				});
			} else {
				const fields = fv.getFields();
				if (fieldname in fields) {
					fv.removeField(fieldname);
				}
			}
		}
	}, [checkedValue]);

	useEffect(() => { // to be updated after render
		if (typeof cbFieldOtherData[fieldname] !== 'undefined') {
			setInputValue(cbFieldOtherData[fieldname]);
		} else if (userData && userData[fieldname]) {
			setInputValue(userData[fieldname]);
		}
	}, [userData, cbFieldOtherData, fieldname]);

	const onChange = (e) => {
		const value = e.target.value;
		setInputValue(value);

		const payload = {
			...cbFieldOtherData,
			[fieldname]: value
		};

		dispatch({type: 'SET_CBFIELD_OTHER_DATA', payload: payload});
	}

	return (
		<div className="mb-0">
			<span className="flex-shrink-0">{form_component.other_option_label}</span>
			{checkedValue === 'other' && (
				<div className="form-group text">
					<input
						type="text"
						id={fieldname}
						name={fieldname}
						className="form-control-sm mb-3 form-control"
						value={inputValue}
						onChange={onChange}
					/>
				</div>
			)}
		</div>
	);
}

export default OtherOption;